/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
export const ListPMProducts = [
    {
        name: 'Preparo de Massa',
        id: 1,
        products: [
            {
                id: 1,
                name: 'Pulper',
                img: require('../../assets/images/PM/pulper.png').default,
            },
            {
                id: 2,
                name: 'Cleaners',
                img: require('../../assets/images/PM/cleaner.png').default,
            },
            {
                id: 3,
                name: 'Refinadores',
                img: require('../../assets/images/PM/refinador.png').default,
            },
            {
                id: 4,
                name: 'Depuração',
                img: require('../../assets/images/PM/cesto.png').default,
            },
            {
                id: 5,
                name: 'Telas Inox',
                img: require('../../assets/images/PM/telasinox.png').default,
            },
        ],
    },
    {
        name: 'Formação, Prensa e Secagem',
        id: 2,
        products: [
            {
                id: 1,
                name: 'Elementos de Drenagem',
                img: require('../../assets/images/PM/ceramica.png').default,
            },
            {
                id: 2,
                name: 'Vestimentas',
                img: require('../../assets/images/PM/feltro.png').default,
            },
            {
                id: 3,
                name: 'Bicos',
                img: require('../../assets/images/PM/bicos.png').default,
            },
            {
                id: 4,
                name: 'Raspas',
                img: require('../../assets/images/PM/raspas.png').default,
            },
            {
                id: 5,
                name: 'Equipamentos',
                img: require('../../assets/images/PM/formaredonda.png').default,
            },
        ],
    },
    {
        name: 'Facas',
        id: 3,
        products: [
            {
                id: 1,
                name: 'Rebobinadeira',
                img: require('../../assets/images/PM/rebobinadeira.png')
                    .default,
            },
            {
                id: 2,
                name: 'Facas Retas',
                img: require('../../assets/images/PM/facareta.png').default,
            },
        ],
    },
    {
        name: 'Componentes e Produtos Diversos',
        id: 4,
        products: [
            {
                id: 1,
                name: 'Apalpadores e Guias',
                img: require('../../assets/images/PM/apalpador.png').default,
            },
            {
                id: 2,
                name: 'Válvulas',
                img: require('../../assets/images/PM/valvulas.png').default,
            },
            {
                id: 3,
                name: 'Peças para Bombas',
                img: require('../../assets/images/PM/bomba.png').default,
            },
            {
                id: 4,
                name: 'Filtros',
                img: require('../../assets/images/PM/filtro.png').default,
            },
            {
                id: 5,
                name: 'Telas Especiais',
                img: require('../../assets/images/PM/telasespeciais.png')
                    .default,
            },
            {
                id: 6,
                name: 'Membranas',
                img: require('../../assets/images/PM/membrana.png').default,
            },
            {
                id: 7,
                name: 'Flexseal',
                img: require('../../assets/images/PM/flexseal.png').default,
            },
        ],
    },
    {
        name: 'Equipamentos de Medição',
        id: 6,
        products: [
            {
                id: 1,
                name: 'Feltest',
                img: require('../../assets/images/PM/feltest.png').default,
            },
        ],
    },
];
